export default class PolozkaCennikaListCtrl {

  static $inject = ["CennikService", "$state"];

  constructor(CennikService, $state){
    this.CennikService = CennikService;
    this.$state = $state;

    this.getPolozky();
  }

  getPolozky() {
    this.CennikService.get(this.$state.params.id).then(result => {
      this.itemSource = result;
    });
  }

  onDeletePolozkaClicked(index) {
    if (confirm('Naozaj odstrániť?')) {
      this.CennikService.deletePolozka(this.itemSource.polozky[index].id).then(() => {
        this.itemSource.polozky.splice(index, 1);
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/Cennik/PolozkaCennika/PolozkaCennikaListCtrl.js